import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router";

import { PermissionProvider } from "@/context/PermissionContext";
import { useAppSelector } from "@/hooks/redux";
import i18n from "@/i18n";
import { getLanguage } from "@/redux/app/appSelector";
import router from "@/router";

export default function App() {
  const language = useAppSelector(getLanguage);

  useEffect(() => {
    void i18n.changeLanguage(language);
  }, [language]);

  return (
    <div className="min-h-screen w-full">
      <PermissionProvider>
        <RouterProvider router={router} />
      </PermissionProvider>
      <Toaster position="top-right" />
    </div>
  );
}
